import { useMemo, useState } from 'react';
import { sortBy } from 'lodash';

import { TableHourBlock } from './use-hour-blocks-for-table';

export type HourBlockOrderFields = keyof TableHourBlock;

export const useSortedTableHourBlocks = (tableBlocks: TableHourBlock[]) => {
  const [sort, setSort] = useState<{
    direction?: 'descend' | 'ascend' | null;
    field?: HourBlockOrderFields;
  }>({});

  const sortedBlocks = useMemo(() => {
    let copy = [...tableBlocks];

    switch (sort.field || 'date') {
      case 'date':
        copy = sortBy(copy, (it) => it.inOutEntry.startedAt);
        break;
      case 'hourType':
        copy = sortBy(copy, (it) => it.hourType);
        break;
      case 'costCenter':
        copy = sortBy(copy, (it) => it.costCenter);
        break;
      case 'unitAndLocation':
        copy = sortBy(copy, (it) => it.unitAndLocation.join());
        break;
      case 'inOut':
        copy = sortBy(copy, (it) => it.inOut);
        break;
      case 'lunchBreak':
        copy = sortBy(copy, (it) => it.lunchBreak);
        break;
      case 'totalTime':
        copy = sortBy(copy, (it) => it.totalTime);
        break;
      case 'notes':
        copy = sortBy(copy, (it) => it.notes);
        break;
    }

    if (sort.direction === 'descend') {
      copy.reverse();
    }

    return copy;
  }, [tableBlocks, sort]);

  return [sortedBlocks, sort, setSort] as const;
};
